import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectExchangeRate, selectPriceDisplayMode } from '../slice/storefrontSlice';
import { formatPrice } from '../utils/format';

/** Formateador ligado a la tasa y al modo efectivo del partner (evita pasar la tasa por props). */
export const usePrice = () => {
  const rate = useSelector(selectExchangeRate);
  const mode = useSelector(selectPriceDisplayMode);
  return useCallback((amount: number) => formatPrice(amount, rate, mode), [rate, mode]);
};
